import { Button, Text } from "@/components";
import { useApp } from "@/hooks";
import clsx from "clsx";
import { FaArrowRight } from "react-icons/fa6";

const LEFT_REVIEWS = [
  {
    brandLogoSrc: "deepwaters.png",
    review:
      "I’m sold! It does what I need and doesn’t cost millions of dollars.",
    avatarSrc: "carlton_hoyt_deepwaters.jpeg",
    author: "Carlton Hoyt",
  },
  {
    brandLogoSrc: "topl.png",
    review:
      "I used T12 to run multiple scenarios while negotiating our financing. It helped me find terms that satisfied both parties.",
    avatarSrc: "kim_wrath.jpeg",
    author: "Kim Wrath",
  },

  {
    brandLogoSrc: "junk_theory.jpeg",
    review:
      "Modeling on T12 optimized my current raise and my plans for future raises.",
    avatarSrc: "justin_wolff.jpeg",
    author: "Justin Wolff",
  },
  {
    brandLogoSrc: "patchr_io.jpeg",
    review:
      "T12 dilution & exit simulations saved our butts so many times... no way I'm paying $15k or whatever to Carta to get modeling when it comes packaged in T12 for $240.",
    avatarSrc: "eric_schneider.jpeg",
    author: "Eric Schneider",
  },
  {
    brandLogoSrc: "bnnano.jpeg",
    review:
      "After our crowdfunding campaign Carta quoted us more than $60,000 annually - with T12 we pay just $240/year, and get even more tools and features. On top of that, their support and customer service exceeded our expectations. T12 has our highest recommendation.",
    avatarSrc: "steve_wilcenski.jpeg",
    author: "Steve Wilcenski",
  },
  {
    brandLogoSrc: "ziggurat.jpeg",
    review:
      "Spreadsheets made it impossible to visualize my startup’s equity breakdown with open SAFEs and options I planned to issue. All my problems disappeared after I switched to T12. Dilution & exit modeling was critical to plan for future rounds. Onboarding was easy and customer service is unmatched.",
    avatarSrc: "sia_nazari.jpeg",
    author: "Sia Nazari",
  },
];

const RIGHT_REVIEWS = [
  {
    brandLogoSrc: "resilienci-ai.webp",
    review:
      "T12 meets 100% of our cap table and shareholder requirements. They continue to add features and actually engage with their customer base regarding the tech stack. I love the team and product. The T12 Migration? Awesome.",
    avatarSrc: "eric_klasson.jpg",
    author: "Eric Klasson",
  },
  {
    brandLogoSrc: "ge_capital.jpeg",
    review:
      "With founders raising on Notes &amp; SAFEs across different caps and discounts, there’s no clarity on how my investments will convert in a priced round or upon exit. As an investor I was impressed when my first startup showed me their T12 cap table dilution &amp; exit simulation and brought out my checkbook.",
    avatarSrc: "anand_rao.jpeg",
    author: "Anand Rao",
  },
  {
    brandLogoSrc: "sunfly_white.webp",
    review:
      "After Carta raised their prices (again) we began shopping around for another cap table management platform. Couldn’t be happier with T12.ai in terms of value, functionality, and support. Highly recommended!",
    avatarSrc: "michael_croix.jpeg",
    author: "Michael Croix",
  },
  {
    brandLogoSrc: "westrive_turquoise.png",
    review:
      "Don’t spend all the money you’ve raised on cap table software. Use T12 to save money and get your cap table sorted even faster.",
    avatarSrc: "cory_mckane.jpeg",
    author: "Cory McKane",
  },
  {
    brandLogoSrc: "dancefight_yellow.png",
    review:
      "T12’s product is much more friendly for the entrepreneur than Carta's.",
    avatarSrc: "richard_sloan.jpeg",
    author: "Richard Sloan",
  },
];

export const Testimonials = () => {
  const ClientReviews = ({ className = "", left = false }) => {
    const { screen } = useApp();

    return (
      <div className={clsx("relative overflow-hidden", className)}>
        <div
          className={clsx(
            "flex flex-col gap-4 absolute top-0 left-0 overflow-hidden",
            { "animate-testimonials": left },
            { "animate-testimonials--reverse": !left }
          )}
        >
          {(screen === ""
            ? [
                ...LEFT_REVIEWS,
                ...RIGHT_REVIEWS,
                ...LEFT_REVIEWS,
                ...RIGHT_REVIEWS,
              ]
            : left
            ? [...LEFT_REVIEWS, ...LEFT_REVIEWS]
            : [...RIGHT_REVIEWS, ...RIGHT_REVIEWS]
          ).map(({ brandLogoSrc, review, avatarSrc, author }, rIdx) => (
            <div
              key={rIdx}
              className="review flex flex-col gap-4 bg-third p-8 rounded-2xl"
            >
              <img
                className="w-6 h-6 rounded-full"
                src={`/images/testimonials/${brandLogoSrc}`}
                alt="brand-logo"
              />
              <div className="text-white text-lg">“{review}”</div>
              <div className="flex items-center gap-2 text-sm text-secondary">
                <img
                  className="w-8 h-8 rounded-full"
                  src={`/images/testimonials/${avatarSrc}`}
                  alt={author}
                />
                <span>{author}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="container mx-auto">
      <div className="grid xl:grid-cols-2 gap-10 md:gap-20">
        <div className="flex xl:hidden flex-col gap-4 md:gap-12 justify-center">
          <Text.Heading className="text-white text-center">
            Testimonials
          </Text.Heading>

          <div className="text-lg md:text-2xl text-center">
            Trusted and loved by startups ranging from pre-seed bootstrapped to
            late stage venture backed.
          </div>

          <div>
            <Button
              className="flex items-center justify-center gap-2 px-4 py-4 md:px-12 md:py-5 text-lg md:text-2xl"
              href="https://calendly.com/dustint12/30min"
            >
              <span>Schedule a Free Cap Table Consultation</span>
              <FaArrowRight />
            </Button>
          </div>
        </div>

        <div className="relative grid md:grid-cols-2 gap-4 min-h-[480px] xl:min-h-[640px]">
          <ClientReviews left />

          <ClientReviews className="hidden md:block" />

          <div
            className="absolute left-0 right-0 top-0 bottom-0 z-50 inset-0"
            style={{
              backgroundImage:
                "linear-gradient(#17181d, #f4f6f700 10% 90%, #17181d)",
            }}
          ></div>
        </div>

        <div className="hidden xl:flex flex-col gap-12 justify-center">
          <Text.Heading className="text-white">Testimonials</Text.Heading>

          <div className="text-2xl">
            Trusted and loved by startups ranging from pre-seed bootstrapped to
            late stage venture backed.
          </div>

          <div>
            <Button
              className="flex items-center gap-2 px-12 py-5 text-2xl"
              href="https://calendly.com/dustint12/30min"
            >
              <span>Schedule a Free Cap Table Consultation</span>
              <FaArrowRight />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
